import { Directive } from '@angular/core';

@Directive({
  selector: '[valueTemplate]',
  standalone: true,
})
export class ValueTemplateDirective {}
